<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="0.5" y="0.5" width="23" height="23" rx="3.5" stroke="#113A41" />
    <path d="M5.125 7H18.875" stroke="#113A41" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M5.125 12H18.875" stroke="#113A41" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M5.125 17H13.25" stroke="#113A41" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M16.375 17H20.125" stroke="#113A41" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M18.25 15.125V18.875" stroke="#113A41" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
  </svg>
</template>
